import { Component, HostListener, Inject, InjectionToken, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { filterSelectionState } from '../search-cars-component/search-cars.helper.consts';

export const MY_WINDOW_TOKEN = new InjectionToken<Window>('Window');

@Component({
  selector: 'app-quiz-submit-error',
  templateUrl: './quiz-submit-error.component.html',
  styleUrls: ['./quiz-submit-error.component.scss']
})

export class QuizSubmitErrorComponent implements OnInit {

  constructor(private router:Router, @Inject(MY_WINDOW_TOKEN) private window: Window) {
    history.pushState(null, '', window.location.origin+'/search-inventory/');
    sessionStorage.removeItem(filterSelectionState);
  }

  @HostListener('window:popstate', ['$event'])
  onPopState(event:any) {
    // browser back button event
    history.pushState(null, '', this.window.location.origin+'/search-inventory/');
    this.window.location.replace(this.window.location.origin+'/search-inventory/')
  }

  ngOnInit(): void {

    window.scrollTo(0, 0);
  }

  BeginNew(){
    this.router.navigate(['/search-inventory']);
  }
}
